module.exports = __webpack_public_path__ + "img/ico_rule_deco_left.d819e4c0.svg";